var Module = {
    name: 'analytics',
    options: {
        cache: true,
        eventName: null,
        orderId: $('meta[name="order"]').attr('content'),
        isBot: $('meta[name="is_bot"]').attr('content'),
        testMode: $('meta[name="test_mode"]').attr('content'),
        url: 'address/paid',
        eventId: $('meta[name="facebook-pixel-event-token"]').attr('content'),
        userToken: $('meta[name="user-token"]').attr('content'),
    },
    eventNames: {
        step1: 'AddToCard',
        step2: 'InitiateCheckout',
        step3: 'Purchase',
        step3_minibox: 'PurchaseMinibox'
    },

    send: function(eventName, cache) {
        if (Module.options.isBot || Module.options.testMode) {
            return;
        }

        let urlForStep = eventName;

        if (eventName === 'step3_success') {
            eventName = 'step3';
        }

        Module.options.eventName = eventName;
        Module.options.cache = cache;

        let eventId = Module.options.eventId;

        if (eventName !== 'step1' && Module.eventNames.hasOwnProperty(eventName)) {
            eventId = Module.eventNames[eventName] + '__' + eventId;
        }
        Module.cacheRemember(function () {

            if (window.google_tag_manager) {
                $('form button[type="submit"]').attr('disabled', true).css({
                    'opacity': '0.5',
                    'cursor': 'default'
                });
            }

            const analyticsData = {
                'event': eventName,
                'event_id': eventId,
                'external_id': Module.options.userToken,
                'eventCallback' : function() {
                    $('form button[type="submit"]').removeAttr('disabled').removeAttr('style');
                },
                'eventTimeout' : 2000,
            }

            let preSendUrl;

            switch (urlForStep) {
                case 'step3_success':
                case 'step3_minibox':
                    preSendUrl = 'success/paid'
                    break;
                case 'step3':
                case 'step3_minibox':
                    preSendUrl = 'address/paid'
                    break;
                case 'step2':
                    preSendUrl = 'payment/init'
                    break;
                default:
                    preSendUrl = null;
                    break;
            }

            if (preSendUrl !== null) {
                $.ajax({
                    type: 'POST',
                    url: preSendUrl,
                    dataType: "json",
                    headers: {
                        'Accept': 'application/json'
                    }
                }).done(function (response) {
                    analyticsData.event_id = Module.eventNames[eventName] + '__' + response.order_token;
                    analyticsData.order_period_name = response.order_period_name;
                    analyticsData.email = response.email;
                    analyticsData.phone_number = response.phone;
                    if (response.address) {
                        analyticsData.address = response.address;
                    }
                    if (response.order_promo_code) {
                        analyticsData.order_promo_code = response.order_promo_code;
                        analyticsData.order_promo_alias = response.order_promo_alias;
                    }
                    if (response.order_price) {
                        analyticsData.order_value = response.order_price;
                        analyticsData.order_currency = response.order_currency;
                    }

                    dataLayer.push(analyticsData);
                });
            } else {
                dataLayer.push(analyticsData);
            }
        })
    },

    generateCacheKey: function () {
        return 'analytics.' + Module.options.eventName + '_' + Module.options.orderId;
    },

    cacheRemember: function (callback) {
        var cacheKey = Module.generateCacheKey();
        if (Module.options.cache === false || !localStorage.getItem(cacheKey)) {
            callback();

            localStorage.setItem(cacheKey, '1');
        }
    },
}

module.exports = Module
